import { get, orderBy } from "es-toolkit/compat";

// Format string value into lowercase
function getValue(value) {
  if (typeof value === "string") {
    return value.toLowerCase();
  }

  return value;
}

export function SortListByType(array, sortBy, sortType) {
  return orderBy(array, [(row) => getValue(get(row, sortBy))], [sortType]);
}
